module.exports = __webpack_public_path__ + "img/wx@2x.9df5be24.png";